import {
  addTemplate,
  AddTemplate,
  getTemplateDetail,
  getTemplateList,
  GetTemplateList,
  deleteTemplate,
  editTemplate,
  getTemplateFormat,
} from '@/api/dp-template'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { t } from '@/i18n'

export const useGetTemplateFormat = () => {
  const { runAsync: run, data } = useRequest(() => getTemplateFormat(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取文件格式列表失败'))
    },
  })

  return [data?.data?.items || [], run] as const
}
export const useGetTemplateList = () => {
  const { runAsync: run, data } = useRequest((params: GetTemplateList) => getTemplateList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取模板列表失败'))
    },
  })

  return [data?.data || {}, run] as const
}

export const useAddTemplate = () => {
  const { runAsync: run } = useRequest((params: AddTemplate) => addTemplate(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('添加模板失败'))
    },
  })

  return [run] as const
}

export const useGetTemplateDetail = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(params => getTemplateDetail(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取模板详情失败'))
    },
  })

  return [data?.data || {}, run, loading] as const
}

export const useDeleteTemplate = () => {
  const { runAsync: run } = useRequest(params => deleteTemplate(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除模板失败'))
    },
  })

  return [run] as const
}

export const useEditTemplate = () => {
  const { runAsync: run } = useRequest(data => editTemplate(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('编辑模板失败'))
    },
  })
  return [run] as const
}
